import Api from '../api';
import { ChatUser } from '../../Components/Chat/types';

export type GetChatTokenResult = {
  user: ChatUser;
  token: string;
};

const endpoint = (userId: string, path: string) =>
  `/users/${userId}/chat${path}`;

const ChatAPI = {
  async getChatToken(userId: string): Promise<GetChatTokenResult> {
    return Api.post(endpoint(userId, '/token'));
  },
};

export default ChatAPI;
